import { fmtDate } from "@/lib/constants";
import { StepShell } from "./StepShell";

export const CloseStep = ({ t }) => {
  if (!["Resolved", "Closed"].includes(t.status)) return null;
  return (
    <StepShell n={3} testid="step-close" state="done" title="Ticket closed"
      hint={`${t.close_note || "Closed"}${t.closed_by ? ` · by ${t.closed_by}` : ""}${t.resolved_date ? ` on ${fmtDate(t.resolved_date)}` : ""}`} />
  );
};
